/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
// eslint-disable-next-line @typescript-eslint/no-var-requires
import { cpf, cnpj } from 'cpf-cnpj-validator'
import { IMask } from 'react-imask'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export const checkNullNumber = (number: number | undefined) => {
  if (number === null || number === undefined) {
    return 's/n'
  } else {
    return number
  }
}

export const formatarTelefone = (numero: string) => {
  const numeros = numero?.replace(/\D/g, '')

  if (numeros?.length === 10) {
    return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 6)}-${numeros.slice(6)}`
  } else if (numeros?.length === 11) {
    return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 7)}-${numeros.slice(7)}`
  } else {
    return numero
  }
}

export const convertMes = (mes: number) => {
  return mes + 1
}

export const getDateOnly = (date: Date) => {
  const cleanedDate = new Date(date.setHours(0, 0, 0, 0))
  return cleanedDate
}

export const formatarCPFCNPJ = (documento: string) => {
  const numeros = documento?.replace(/\D/g, '')
  if (numeros?.length === 11) {
    return `${numeros.slice(0, 3)}.${numeros.slice(3, 6)}.${numeros.slice(
      6,
      9
    )}-${numeros.slice(9)}`
  } else if (numeros?.length === 14) {
    return `${numeros.slice(0, 2)}.${numeros.slice(2, 5)}.${numeros.slice(
      5,
      8
    )}/${numeros.slice(8, 12)}-${numeros.slice(12)}`
  } else {
    return documento
  }
}

export const localDateToDate = (value: string) => {
  const [year, month, day] = value.split('-')
  return new Date(Number(year), Number(month) - 1, Number(day))
}

export const removeformatarCPFCNPJ = (dados: string) => {
  const cpfWithoutFormat = dados.replace(/[^\d]/g, '')
  let login: string = ''
  return (login = cpfWithoutFormat)
}

export const removeformatacaoTelefone = (dados: string) => {
  return dados.replaceAll(/[()\s-]+/g, '')
}

export const removeformatacaoCep = (dados: string) => {
  return dados.replaceAll(/[-. ]/g, '')
}

export const dateAsString = (date: Date) => {
  return date.toLocaleDateString('pt-br')
}

export const validarCPFCNPJ = (cpfcnpj: string) => {
  if (cpfcnpj.length > 0) {
    if (cpfcnpj.length === 14) {
      return cnpj.isValid(cpfcnpj, false)
    } else {
      return cpf.isValid(cpfcnpj, false)
    }
  }
}

export const formataCep = (val: string) => {
  return val
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1')
}

export const maskCpfCnpj = IMask.createMask({
  mask: [{ mask: '000.000.000-00' }, { mask: '00.000.000/0000-00' }],
})

export const maskCelular = IMask.createMask({
  mask: [{ mask: '(00) 00000-0000' }, { mask: '(00) 0000-0000' }],
})

export const maskCEP = IMask.createMask({
  mask: '00000-000',
})

export const getErrorMessage = (err: unknown) => {
  const erro = Object.getOwnPropertyDescriptors(err as object)
  return erro?.message?.value
}

export const formatMoneyPtBr = (dinheiro: number) => {
  return dinheiro.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })
}

export const removeHora = (data: any) => {
  if (!data) return data
  return new Date(data).toISOString().split('T')[0]
}

export const convertDateToBrazil = (data: Date) => {
  return format(data, 'yyyy-MM-dd', { locale: ptBR })
}

export const convertDateAndHoursToBrazil = (data: Date) => {
  return format(data, 'dd/MM/yyyy HH:mm')
}

export const arrayToDate = (arr: number[]): Date | null => {
  if (!Array.isArray(arr) || arr.length < 3) return null
  const [ano, mes, dia, hora = 0, minuto = 0, segundo = 0] = arr
  return new Date(ano, mes - 1, dia, hora, minuto, segundo)
}

export const convertDateToBrazilUtc = (val: string) => {
  const [a, m, d] = val.split('-')

  return new Date(Number(a), Number(m) - 1, Number(d))
}

const meses: Record<string, number> = {
  janeiro: 0,
  fevereiro: 1,
  março: 2,
  abril: 3,
  maio: 4,
  junho: 5,
  julho: 6,
  agosto: 7,
  setembro: 8,
  outubro: 9,
  novembro: 10,
  dezembro: 11,
}

export const parseDataPortugues = (data: string) => {
  const regex = /(\d{1,2}) de ([a-zç]+), (\d{4})/i
  const partes = data.match(regex)

  if (!partes) return null

  const dia = Number(partes[1])
  const mes = meses[partes[2].toLowerCase()]
  const ano = Number(partes[3])

  return new Date(ano, mes, dia)
}
